import {
  FsReducerAction,
  FsDataState,
  FsReducerActionUpdateVisitorVariation,
  FsCampaign,
  FsSearchCampaigns,
  VisitorVariationUpdateParam,
} from '../type';

export const fsDataInitialState: FsDataState = {
  fsEnvId: '',
  visitorAllocatedCampaign: [],
  visitorExposedCampaign: [],
  fsExposedCampaigns: [],
  fsUnExposedCampaigns: [],
};

function filterVisitorAllocatedCampaigns(
  state: FsDataState,
  action: FsReducerActionUpdateVisitorVariation
): FsCampaign[] {
  return state.bucketingFile?.campaigns?.filter((item) => action.value[item.id]) || [];
}

function filterVisitorExposedCampaigns(
  state: FsDataState,
  action: FsReducerActionUpdateVisitorVariation
): FsCampaign[] {
  if (action.param === VisitorVariationUpdateParam.NewNavigation) {
    return filterVisitorAllocatedCampaigns(state, action);
  }

  const allocatedCampaignIds = new Set(state.visitorAllocatedCampaign.map((campaign) => campaign.id));
  const currentExposedIds = new Set(state.visitorExposedCampaign.map((campaign) => campaign.id));

  return (
    state.bucketingFile?.campaigns?.filter(
      (campaign) =>
        allocatedCampaignIds.has(campaign.id) && (action.value[campaign.id] || currentExposedIds.has(campaign.id))
    ) || []
  );
}

function searchExposedCampaigns(state: FsDataState, action: FsSearchCampaigns): FsCampaign[] {
  if (!action.value) {
    return state.visitorExposedCampaign;
  }
  const campaigns = state.visitorExposedCampaign.filter(
    (item) =>
      item.id.toUpperCase().startsWith(action.value.toUpperCase()) ||
      item.name.toUpperCase().startsWith(action.value.toUpperCase())
  );
  return campaigns;
}
function searchUnExposedCampaigns(state: FsDataState, action: FsSearchCampaigns): FsCampaign[] {
  if (!action.value) {
    return state.visitorAllocatedCampaign;
  }
  const campaigns = state.visitorAllocatedCampaign.filter(
    (item) =>
      item.id.toUpperCase().startsWith(action.value.toUpperCase()) ||
      item.name.toUpperCase().startsWith(action.value.toUpperCase())
  );
  return campaigns;
}

export function fsDataReducer(state: FsDataState, action: FsReducerAction): FsDataState {
  let campaigns: FsCampaign[] = [];
  switch (action.type) {
    case 'setBucketingFile':
      return { ...state, bucketingFile: action.bucketingFile };
    case 'updateVisitorVariations':
      campaigns = filterVisitorAllocatedCampaigns(state, action);
      return {
        ...state,
        visitorVariations: action.value,
        visitorAllocatedCampaign: campaigns,
        fsUnExposedCampaigns: campaigns,
      };
    case 'updateVisitorExposedVariations':
      campaigns = filterVisitorExposedCampaigns(state, action);
      return {
        ...state,
        visitorExposedVariations: action.value,
        visitorExposedCampaign: campaigns,
        fsExposedCampaigns: campaigns,
      };
    case 'searchFsCampaigns':
      return {
        ...state,
        fsExposedCampaigns: searchExposedCampaigns(state, action),
        fsUnExposedCampaigns: searchUnExposedCampaigns(state, action),
      };
    default:
      return state;
  }
}
